import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

const AdsSectionHolder = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .ads-pagination {
    align-self: flex-end;
    margin-top: 4px;
  }

  /* Drag & drop upload zone (wraps folders + ads). */
  .ads-dropzone {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-radius: 8px;
    transition: box-shadow 0.2s, background 0.2s;

    &.drag-over {
      background: ${Colors.primary}0a;
      box-shadow: inset 0 0 0 2px ${Colors.primary};
    }
  }

  /* Centered hint shown while files hover the section. pointer-events: none so
     the drag still reaches the folder cards/rows underneath (folder targeting). */
  .ads-dropzone-overlay {
    position: absolute;
    inset: 0;
    z-index: 5;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border: 2px dashed ${Colors.primaryAccent};
    border-radius: 8px;
    background: ${Colors.extraLightPrimary};
    text-align: center;
    padding: 16px;

    .ads-dropzone-icon {
      font-size: 40px;
      color: ${Colors.primaryAccent};
    }

    .ads-dropzone-title {
      font-size: 16px;
      font-weight: 600;
      color: ${Colors.primaryAccent};
    }

    .ads-dropzone-hint {
      font-size: 13px;
      color: ${Colors.primaryAccent};
    }
  }

  .ads-group {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .group-title {
      font-family: 'Roboto', sans-serif;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      margin: 0;
      color: ${Colors.textStrong};
    }
  }

  .empty-folder-result {
    border: 1px dashed ${Colors.borderStrong};
    border-radius: 6px;

    .ant-result-title {
      font-weight: 600;
    }

    .ant-result-extra {
      max-width: 460px;
      margin: 8px auto 0;
    }
  }

  .folders-row {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 12px;
  }

  .folders-table {
    /* Whole row opens the folder */
    .ant-table-tbody > tr {
      cursor: pointer;
    }

    /* A file is being dragged onto this folder row — highlight it blue to show
       the files will be saved inside that folder. */
    .ant-table-tbody > tr.row-drag-over > td {
      background: ${Colors.extraLightPrimary};
      box-shadow: inset 0 0 0 1px ${Colors.primary};
    }

    .cell-folder {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      color: ${Colors.textStrong};

      .cell-folder-icon {
        color: ${Colors.primaryAccent};
      }
    }
  }
`

export default AdsSectionHolder
